/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetReceivableQueryResponse, GetReceivablePathParams, GetReceivable400, GetReceivable401, GetReceivable403, GetReceivable404, GetReceivable409, GetReceivable500 } from "../../types/financialHubController/GetReceivable.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetReceivableUrl(organizationId: GetReceivablePathParams["organizationId"], receivableId: GetReceivablePathParams["receivableId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/financial/receivables/${receivableId}` as const }
  return res
}

/**
 * @summary Get a receivable with its receipts
 * {@link /api/organizations/:organizationId/financial/receivables/:receivableId}
 */
export async function getReceivable(organizationId: GetReceivablePathParams["organizationId"], receivableId: GetReceivablePathParams["receivableId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetReceivableQueryResponse, ResponseErrorConfig<GetReceivable400 | GetReceivable401 | GetReceivable403 | GetReceivable404 | GetReceivable409 | GetReceivable500>, unknown>({ method : "GET", url : getGetReceivableUrl(organizationId, receivableId).url.toString(), ... requestConfig })
  return res.data
}